import { NATIVE_SOL } from "@stepfinance/common";
import { useEffect, useState } from "react";

import { useMarkets } from "../../contexts/market";
import { useRent } from "./useRent";

export const useAccountRent = (accountList: any[], rentDataLength: number) => {
  const [totalRent, setTotalRent] = useState(0);
  const { priceInUSD } = useMarkets();
  const SOL_PRICE = priceInUSD(NATIVE_SOL.toBase58()) ?? 0;
  const { accountRent, isRentLoading } = useRent(rentDataLength);

  useEffect(() => {
    if (!isRentLoading) {
      setTotalRent(accountList.length * accountRent * SOL_PRICE);
    }
  }, [SOL_PRICE, accountRent, isRentLoading, accountList.length]);

  return { totalRent, isRentLoading };
};
